import * as React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import {
  Modal,
  Fade,
  Card,
  Grid,
  CircularProgress,
  Icon,
  Tooltip,
  InputLabel,
} from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";

//Context
import { useContext } from "react";
import { MessageManager } from "context";
import colors from "assets/theme/base/colors";
import dataProductos from "./dataProductos";
import DataTable from "components/DataTable";
import { useRef } from "react";
import { urlBase } from "services/config";
import { agregarCeros } from "utils/truncate";
import dayjs from "dayjs";
import ModalNuevoProducto from "./ModalNuevoProducto";
import { ConfirmarContext } from "context/ConfirmarContext";

const { inputColors } = colors;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "80%" },
  py: 4,
};
const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;

export default function ModalRecibir({ open, handleClose, remitoElegido, refetch }) {
  const { handleSnackbar } = useContext(MessageManager);
  const { confirmar } = useContext(ConfirmarContext);

  const confirmandoRef = useRef(false);

  const user = JSON.parse(localStorage.getItem("user") || "null");
  const listadoGuardar = useRef([]);

  const { columns, getRows } = dataProductos;

  const [modalNuevoProducto, setModalNuevoProducto] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [nuevosProductos, setNuevosProductos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [numeroEmpleado, setNumeroEmpleado] = useState("");

  //Cambia cantidad de un producto en el listado o de un producto nuevo
  const onChangeCantidad = (e, IdRemito, itemListado) => {
    //JSON parse y stringify para copiar el array de forma profunda y evitar cambiar la referencia del array original.
    listadoGuardar.current.length === 0
      ? remitoElegido.estado == "Recibo parcial"
        ? (listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles_pausa)))
        : (listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles)))
      : null;
    const value = e.target.value;
    let index;
    if (IdRemito) {
      index = listadoGuardar.current.findIndex((item) => item.IdRemito === IdRemito);
    } else {
      index = listadoGuardar.current.findIndex(
        (item) =>
          item.CodProv == itemListado.CodProv &&
          item.Descripcion == itemListado.Descripcion &&
          item.Rubro == itemListado.Rubro &&
          item.COLOR == itemListado.COLOR &&
          item.TALLE == itemListado.TALLE
      );
    }
    listadoGuardar.current[index].Cantidad = value;
    listadoGuardar.current[index].cantidadRecibida = value;
    listadoGuardar.current[index].Sucursal = parsedUser.nombre;
    listadoGuardar.current[index].sucursalDestinoNombre = parsedUser.nombre;
    listadoGuardar.current[index].TipoMovimientoRemito = "Recepción";
  };
  const allRows = useMemo(() => {
    if (remitoElegido?.detalles) {
      setNumeroEmpleado(remitoElegido.empleadoControla);
      if (remitoElegido.estado == "Recibo parcial") {
        let detalles =
          listadoGuardar.current.length > 0 ? listadoGuardar.current : remitoElegido.detalles_pausa;
        // const listadoConcatenado = detalles.concat(nuevosProductos);

        return getRows(detalles, onChangeCantidad, true);
      } else {
        let detalles;
        if (listadoGuardar.current.length === 0) {
          detalles = listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles));
        } else {
          detalles =
            listadoGuardar.current.length > 0 ? listadoGuardar.current : remitoElegido.detalles;
          // const listadoConcatenado = detalles.concat(nuevosProductos);
        }
        detalles.forEach((item) => {
          item.Cantidad = Math.abs(Number(item.Cantidad));
          item.TipoMovimientoRemito = "Recepción";
        });

        return getRows(detalles, onChangeCantidad);
      }
    } else {
      return [];
    }
  }, [remitoElegido, nuevosProductos, listadoGuardar.current]);
  const chequearAjustes = async () => {
    let arrayAjustes = [];

    const confirmarEnvio = async () => {
      if (confirmandoRef.current) return;
      confirmandoRef.current = true;
      await actualizarRemito("Recibido");
      setTimeout(() => {
        confirmandoRef.current = false;
      }, 1000);
    };

    listadoGuardar.current.forEach((item) => {
      let cantidadGuardar = parseInt(item.Cantidad);
      let remitoUsado = remitoElegido.detalles.find(
        (remito) =>
          remito.CodProv == item.CodProv &&
          remito.Descripcion == item.Descripcion &&
          remito.Rubro == item.Rubro &&
          remito.COLOR == item.COLOR &&
          remito.TALLE == item.TALLE
      );
      //Si el producto es nuevo no hay remito usado
      if (!remitoUsado) {
        if (item.Agregado == true) {
          arrayAjustes.push({
            ...item,
            Cantidad: -Number(cantidadGuardar),
            TipoMovimientoRemito: "ajuste",
            Sucursal: remitoElegido.sucursal,
            sucursalDestinoNombre: parsedUser.nombre,
          });
        }
        return;
      }
      let cantidadRemito = parseInt(remitoUsado.Cantidad);
      if (Math.abs(Number(cantidadGuardar)) !== Math.abs(Number(cantidadRemito))) {
        arrayAjustes.push({
          ...item,
          Cantidad: -(cantidadRemito + cantidadGuardar),
          TipoMovimientoRemito: "ajuste",
          Sucursal: remitoElegido.sucursal,
          sucursalDestinoNombre: parsedUser.nombre,
        });
      }
    });
    if (arrayAjustes.length === 0) {
      confirmar({
        title: "Confirmación de guardado",
        message: "¿Está seguro que desea guardar?",
        icon: "save",
        func: () => {
          confirmarEnvio();
        },
      });
    } else {
      confirmar({
        title: "Advertencia",
        message:
          "¿Está seguro que desea continuar? Hay cantidades que tienen diferencias con el remito original.",
        icon: "warning",
        func: () => {
          confirmarEnvio();
        },
      });
    }
  };
  const actualizarRemito = async (estado) => {
    listadoGuardar.current.length === 0
      ? remitoElegido.estado == "Recibo parcial"
        ? (listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles_pausa)))
        : (listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles)))
      : null;
    if (
      listadoGuardar.current.some((item) => parseInt(item.Cantidad) < 0 || item.Cantidad === "") &&
      estado === "Recibido"
    ) {
      handleSnackbar("Todos los items deben tener cantidad", "error");
      return;
    }
    if (estado === "Recibo parcial" && listadoGuardar.current.length === 0) {
      handleSnackbar("Para pausar debe cargar al menos un ítem", "error");
      return;
    }
    let arrayAjustes = [];
    if (estado == "Recibido") {
      listadoGuardar.current.forEach((item) => {
        let cantidadGuardar = parseInt(item.Cantidad);
        let remitoUsado = remitoElegido.detalles.find(
          (remito) =>
            remito.CodProv == item.CodProv &&
            remito.Descripcion == item.Descripcion &&
            remito.Rubro == item.Rubro &&
            remito.COLOR == item.COLOR &&
            remito.TALLE == item.TALLE
        );
        //Si el producto es nuevo no hay remito usado
        if (!remitoUsado) {
          if (item.Agregado == true) {
            arrayAjustes.push({
              ...item,
              Cantidad: -Number(cantidadGuardar),
              TipoMovimientoRemito: "ajuste",
              Sucursal: remitoElegido.sucursal,
              sucursalDestinoNombre: parsedUser.nombre,
            });
          }
          return;
        }
        let cantidadRemito = parseInt(remitoUsado.Cantidad);
        if (Math.abs(Number(cantidadGuardar)) !== Math.abs(Number(cantidadRemito))) {
          arrayAjustes.push({
            ...item,
            Cantidad: -(cantidadRemito + cantidadGuardar),
            TipoMovimientoRemito: "ajuste",
            Sucursal: remitoElegido.sucursal,
            sucursalDestinoNombre: parsedUser.nombre,
          });
        }
      });
    }
    setLoadingSave(true);
    const date = new Date().toLocaleString("af-ZA", {
      hour12: false,
    });
    try {
      console.log("listadoGuardar", listadoGuardar.current);
      console.log("arrayAjustes", arrayAjustes);
      await axios.put(urlBase + "remitoEncabezados/" + remitoElegido.id, {
        ...remitoElegido,
        detalles: listadoGuardar.current
          .filter(
            (item) => !item.dateDel
            // && item.cantidadRecibida > 0
          )
          .concat(arrayAjustes),
        estado: estado,
        empleadoControla: numeroEmpleado,
        dateUpd: date,
        sucursalDestinoNombre: parsedUser.nombre,
        Sucursal: remitoElegido.sucursal,
      });
      handleSnackbar("Actualizado correctamente", "success");
      refetch();
      cerrarModal();
    } catch (error) {
      console.error(error);
      handleSnackbar("Error al actualizar el remito", "error");
    } finally {
      setLoadingSave(false);
    }
  };
  const cerrarModal = () => {
    handleClose();
    setNuevosProductos([]);
    listadoGuardar.current = [];
  };
  const agregarNuevoProducto = (producto) => {
    const productoExistente = listadoGuardar.current.find(
      (item) =>
        producto.CodProv == item.CodProv &&
        producto.Descripcion == item.Descripcion &&
        producto.Rubro == item.Rubro &&
        producto.COLOR == item.COLOR &&
        producto.TALLE == item.TALLE
    );
    if (productoExistente) {
      handleSnackbar("El producto ya fue agregado", "error");
      return;
    }
    setNuevosProductos((prev) => [...prev, producto]);
    listadoGuardar.current.length === 0
      ? remitoElegido.estado == "Recibo parcial"
        ? (listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles_pausa)))
        : (listadoGuardar.current = JSON.parse(JSON.stringify(remitoElegido.detalles)))
      : null;
    listadoGuardar.current = listadoGuardar.current.concat(producto);
  };

  useEffect(() => {
    const getEmpleados = async () => {
      try {
        const response = await axios.get(urlBase + "vendedores");
        setEmpleados(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    getEmpleados();
  }, []);

  const empleadoEnvia = empleados.find((empleado) => {
    return Number(empleado?.NVEND) == remitoElegido?.empleado;
  });

  const empleadoRecibo = empleados.find((empleado) => {
    return Number(empleado?.NVEND) == numeroEmpleado;
  });

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={(event, reason) => {
        if (reason === "escapeKeyDown") {
          cerrarModal();
        }
      }}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox px={3} display={"flex"} justifyContent="space-between" alignItems="end">
            <SoftTypography variant="h5">Recepción de productos</SoftTypography>
            <Tooltip title="Cancelar y cerrar" placement="top">
              <SoftButton
                variant="text"
                color="dark"
                size="large"
                disabled={loadingSave}
                onClick={() => {
                  cerrarModal();
                }}
              >
                Cerrar
                <Icon
                  sx={{
                    ml: 1.5,
                  }}
                >
                  close
                </Icon>
              </SoftButton>
            </Tooltip>
          </SoftBox>
          <Grid container p={3}>
            <Grid item xs={12} display="flex">
              <SoftTypography variant="body2">
                <Icon>receipt</Icon>&nbsp; Número de remito: &nbsp;
              </SoftTypography>
              <SoftTypography variant="body2" fontWeight="bold">
                {remitoElegido?.codigoSucursal
                  ? agregarCeros(remitoElegido?.codigoSucursal, 4) + " - " + remitoElegido?.numero
                  : null}
              </SoftTypography>
            </Grid>
            <Grid item xs={12} display="flex">
              <SoftTypography variant="body2">
                <Icon>factory</Icon>&nbsp; Remitente: &nbsp;
              </SoftTypography>
              <SoftTypography variant="body2" fontWeight="bold">
                {remitoElegido?.sucursal}
              </SoftTypography>
            </Grid>
            <Grid item xs={12} display="flex">
              <SoftTypography variant="body2">
                <Icon>query_builder</Icon>&nbsp; Fecha: &nbsp;
              </SoftTypography>
              <SoftTypography variant="body2" fontWeight="bold">
                {dayjs(remitoElegido?.fecha).format("DD-MM-YYYY HH:mm")}
              </SoftTypography>
            </Grid>
            <Grid item xs={12} display="flex">
              <SoftTypography variant="body2">
                <Icon>person</Icon>&nbsp; Empleado que envía: &nbsp;
              </SoftTypography>
              <SoftTypography variant="body2" fontWeight="bold">
                {empleadoEnvia ? empleadoEnvia.NOMBRE : "No cargado"}
              </SoftTypography>
            </Grid>
            <Grid item xs={8} mt={2}>
              <InputLabel>
                <SoftTypography variant="subtitle2" fontWeight="bold">
                  Número de empleado que controla
                </SoftTypography>
              </InputLabel>
              <SoftInput
                type="number"
                value={numeroEmpleado}
                onChange={(e) => setNumeroEmpleado(e.target.value)}
                error={!empleadoRecibo}
              />
              <Grid item xs={5} display="flex" alignItems="flex-end">
                <SoftTypography variant="subtitle2" px={1}>
                  <Icon>person</Icon>
                  {empleadoRecibo ? empleadoRecibo.NOMBRE : " - "}
                </SoftTypography>
              </Grid>
            </Grid>
            <Grid
              item
              xs={4}
              display="flex"
              justifyContent="flex-end"
              alignItems="flex-start"
              mt={2}
            >
              <Tooltip title="Agregar producto" placement="top">
                <SoftButton
                  variant="gradient"
                  size="large"
                  color="primary"
                  onClick={() => {
                    setModalNuevoProducto(true);
                  }}
                  disabled={loadingSave}
                >
                  <Icon>add</Icon>
                </SoftButton>
              </Tooltip>
            </Grid>
          </Grid>
          <SoftBox px={3}>
            <Card>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{
                    overflowY: "auto",
                    maxHeight: "40vh",
                  }}
                >
                  <DataTable columns={columns} rows={allRows} />
                </Grid>
              </Grid>
            </Card>
          </SoftBox>
          <SoftBox display="flex" justifyContent="flex-end" alignItems="center" px={3} pt={3}>
            <SoftBox mr={2}>
              <SoftButton
                variant="gradient"
                color="primary"
                size="large"
                onClick={() => {
                  actualizarRemito("Recibo parcial");
                }}
                disabled={loadingSave}
              >
                <Icon
                  sx={{
                    mr: 0.4,
                  }}
                >
                  pause
                </Icon>
                {loadingSave ? (
                  <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                ) : (
                  "Pausar"
                )}
              </SoftButton>
            </SoftBox>
            <SoftBox>
              <SoftButton
                variant="gradient"
                color="dark"
                size="large"
                onClick={() => {
                  chequearAjustes();
                }}
                disabled={loadingSave || !empleadoRecibo}
              >
                {!loadingSave ? (
                  <>
                    <Icon
                      sx={{
                        mr: 0.4,
                      }}
                    >
                      save
                    </Icon>
                    {loadingSave ? (
                      <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                    ) : (
                      "Guardar"
                    )}
                  </>
                ) : (
                  <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                )}
              </SoftButton>
            </SoftBox>
            <ModalNuevoProducto
              open={modalNuevoProducto}
              handleClose={() => setModalNuevoProducto(false)}
              agregarNuevoProducto={agregarNuevoProducto}
              remito={remitoElegido}
            />
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalRecibir.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  remitoElegido: PropTypes.object,
  refetch: PropTypes.func,
};
